import React from 'react';
import PropTypes from 'prop-types';
import { Button, Modal } from 'react-bootstrap';
import { withMenu } from '../../../containers/Menus';
import withMenuModals from '../../../containers/Modals/menu';

class DeleteMenuModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isDeleted: false,
      error: false,
    };
  }

  deleteMenu = () => {
    this.props.deleteMenu(this.props.modal.menuDelete.id);
  };

  componentDidUpdate() {
    const { isDeleteMenuFinished, finishDeleteMenu, getMenus } = this.props;
    if (isDeleteMenuFinished) {
      finishDeleteMenu();
      this.setState({ isDeleted: true });
      getMenus();
    }
  }

  closeModal = () => {
    this.props.closeModal();
    setTimeout(() => {
      this.setState({ isDeleted: false, error: false });
    }, 1000);
  };

  render() {
    return (
      <Modal
        show={this.props.modal.showDeleteMenuModal}
        container={this.props.container}
        className="newMenuModal menu-modal-delete"
        onHide={this.props.closeModal}
        onExited={this.onExited}
      >
        <Modal.Header closeButton>
          {!this.state.error ? (
            <div>
              <div className={this.state.isDeleted ? 'icon-deleted' : 'icon-delete'} />
              <Modal.Title>
                {this.state.isDeleted ? 'cardápio excluído' : 'excluir cardápio'}
              </Modal.Title>
              <p className="subtitle">
                {this.state.isDeleted
                  ? 'O cardápio foi excluído com sucesso!'
                  : 'Você tem certeza que deseja excluir permanentemente este cardápio?'}
              </p>
            </div>
          ) : (
            <div>
              <Modal.Title>erro</Modal.Title>
              <p className="subtitle">
                Ocorreu um erro ao excluir o cardápio. Por favor tente novamente mais tarde.
              </p>
            </div>
          )}
        </Modal.Header>
        <Modal.Body className="modal-body-sm">
          <div className="divisor" />
        </Modal.Body>
        <Modal.Footer>
          {this.state.isDeleted || this.state.error ? (
            <div className="btn-group">
              <Button className="confirm" onClick={this.closeModal}>
                Ok
              </Button>
            </div>
          ) : (
            <div className="btn-group">
              <Button className="cancel" id="cancelMenu" onClick={this.closeModal}>
                Cancelar
              </Button>
              <Button className="confirm" id="confirmMenu" onClick={this.deleteMenu}>
                Excluir
              </Button>
            </div>
          )}
        </Modal.Footer>
      </Modal>
    );
  }
}

DeleteMenuModal.propTypes = {
  container: PropTypes.object,
};

export default withMenu(withMenuModals(DeleteMenuModal));



// WEBPACK FOOTER //
// ./src/components/GenericModal/DeleteMenuModal/index.js